export default "__VITE_ASSET__DId$v4uc__"